module.exports = __webpack_public_path__ + "static/media/tools-highliter.83390e23.svg";